/// <amd-module name="Wiki/PageRenamePanel/WikiPageArtifactHelper" />
import { format } from "VSS/Core/Util/String";
import { encodeUri } from "VSS/Platform/Util/Linking";
import { RepoConstants } from "Wiki/ViewCommon/Constants";

// {projectId}/{wikiId}/{wikiPagePath}
export const ToolSpecificRefIdFormat = "{0}/{1}/{2}";
export const ArtifactToolName = "Wiki";
export const ArtifactTypeName = "WikiPage";

export function getWikiPagePathFromArtifactId(id: string | undefined): string {
    let pagePath = "";
    if (id) {
        const pagePathStartIndex: number = id.split(RepoConstants.PathSeparator, 2).join(RepoConstants.PathSeparator).length;
        pagePath = id.substring(pagePathStartIndex);
    }

    return pagePath;
}

export function getWikiIdFromArtifactId(id: string | undefined): string {
    let wikiId = "";
    if (id) {
        const parts = id.split(RepoConstants.PathSeparator);
        if (parts.length >= 3) {
            wikiId = parts[1];
        }
    }

    return wikiId;
}

export function getProjectIdFromArtifactId(id: string | undefined): string {
    let projectGuid = "";
    if (id) {
        const parts = id.split(RepoConstants.PathSeparator);
        if (parts.length >= 3) {
            projectGuid = parts[0];
        }
    }

    return projectGuid;
}

export function getWikiPageArtifactId(projectGuid: string | undefined, wikiId: string | undefined, wikiPagePath: string | undefined): string {
    if (projectGuid && wikiId && wikiPagePath) {
        wikiPagePath = wikiPagePath.charAt(0) === RepoConstants.PathSeparator ? wikiPagePath.substring(1) : wikiPagePath;
        return format(ToolSpecificRefIdFormat, projectGuid, wikiId, wikiPagePath);
    }

    return "";
}

export function getWikiPageArtifactUri(id: string | undefined): string {
    if (id) {
        return encodeUri({
            id: id,
            tool: ArtifactToolName,
            type: ArtifactTypeName
        });
    }

    return "";
}
